// removed by extract-text-webpack-plugin
module.exports = {"root":"FontFamilyPicker__root___3oATE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/FontFamilyPicker/FontFamilyPicker.scss
// module id = 998
// module chunks = 0